import {Bounce, toast, ToastOptions} from 'react-toastify';
import {transString} from './lang/translations.ts';

const toastOptions: ToastOptions = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    transition: Bounce,
};

export function handleErrors(errors: unknown) {
    if (Array.isArray(errors)) {
        Object.values(errors).forEach((error) => {
            if (typeof error === 'string') {
                toast.warning(error, toastOptions);
            }
        });
    } else if (typeof errors === 'object' && errors !== null) {
        if (Object.values(errors as {[key: string]: string}).includes('validation')) {
            toast.warning(transString('general.flash.validation'), toastOptions);
        }
    }
}

export function handleSuccess(message?: string) {
    if (!message) {
        message = transString('general.flash.success');
    }
    toast.success(message, toastOptions);
}
